<div class="flex flex-1">
  <dx-form
    [formData]="formData"
    (onFieldDataChanged)="onFieldDataChanged()"
    [colCount]="4"
    [readOnly]="readonly"
    class="flex-1"
  >
    <dxi-item
      dataField="title"
      [label]="{
        text: 'Titolo' | transloco,
        location: 'top',
        visible: true,
        showColon: false
      }"
    ></dxi-item>
    <dxi-item
      dataField="size"
      editorType="dxSelectBox"
      [label]="{
        text: 'Dimensione titolo' | transloco,
        location: 'top',
        visible: true,
        showColon: false
      }"
      [editorOptions]="{
        valueExpr: 'value',
        displayExpr: 'display',
        dataSource: [
          { value: 'h1', display: 'H1' | transloco },
          { value: 'h2', display: 'H2' | transloco },
          { value: 'h3', display: 'H3' | transloco },
          { value: 'h4', display: 'H4' | transloco },
          { value: 'h5', display: 'H5' | transloco }
        ]
      }"
    ></dxi-item>
    <dxi-item
      dataField="alignment"
      editorType="dxSelectBox"
      [label]="{
        text: 'Allineamento' | transloco,
        location: 'top',
        visible: true,
        showColon: false
      }"
      [editorOptions]="{
        valueExpr: 'value',
        displayExpr: 'display',
        dataSource: [
          { value: 'left', display: 'Sinistra' | transloco },
          { value: 'center', display: 'Centro' | transloco },
          { value: 'right', display: 'Destra' | transloco }
        ]
      }"
    ></dxi-item>
    <dxi-item
      dataField="fontWeight"
      editorType="dxSelectBox"
      [label]="{
        text: 'Font' | transloco,
        location: 'top',
        visible: true,
        showColon: false
      }"
      [editorOptions]="{
        valueExpr: 'value',
        displayExpr: 'display',
        dataSource: [
          { value: 'extrabold', display: 'Extra bold' | transloco },
          { value: 'bold', display: 'Bold' | transloco },
          { value: 'semibold', display: 'Semi bold' | transloco },
          { value: 'medium', display: 'Medium' | transloco },
          { value: 'normal', display: 'Normal' | transloco },
          { value: 'light', display: 'Light' | transloco },
          { value: 'extralight', display: 'Extra light' | transloco },
          { value: 'thin', display: 'Thin' | transloco }
        ]
      }"
      class="font-"
    ></dxi-item>
  </dx-form>
</div>
